import { ResultCode } from '../../types/global-types';

export const KLARNA_WIDGET_URL = 'https://x.klarnacdn.net/kp/lib/v1/api.js';

export const KLARNA_REFUSED_RESULT_CODE: ResultCode = 'Refused';
